import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useAddNodeType = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.ADD_NODE_TYPE],
    (data) => ApiService.addNodeType(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_NODE_TYPE);
        setShowAddForm(false)
        toast.success('Node Type added successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useAddNodeType